import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export function mapShareholderFromApi(d) {
  const companyId = d.companyId ?? d.branchId;
  return {
    id: d.id,
    name: d.name ?? '',
    branchId: companyId,
    branch: d.companyName ?? d.branchName ?? '',
    ownership: Number(d.ownershipPercentage ?? 0),
    type: d.type ?? 'مساهم',
    shareStockType: d.shareStockType ?? 'سهم عادي',
    phone: d.phone ?? '',
    email: d.email ?? '',
    bankName: d.bankName ?? '',
    bankAccountNumber: d.bankAccountNumber ?? '',
    iban: d.iban ?? '',
    userName: d.userName ?? '',
    hasAccount: Boolean(d.hasAccount),
    status: d.isActive ? 'active' : 'inactive',
  };
}

export function mapShareholderFormToPayload(form) {
  return {
    name: form.name?.trim() ?? '',
    companyId: Number(form.branchId),
    ownershipPercentage: Number(form.ownership),
    type: form.type?.trim() ?? 'مساهم',
    shareStockType: form.shareStockType?.trim() ?? 'سهم عادي',
    phone: form.phone?.trim() || null,
    email: form.email?.trim() || null,
    bankName: form.bankName?.trim() || null,
    bankAccountNumber: form.bankAccountNumber?.trim() || null,
    iban: form.iban?.trim() || null,
    userName: form.userName?.trim() || null,
    password: form.password?.trim() || null,
    isActive: form.status === 'active',
  };
}

export async function fetchShareholders() {
  const res = await fetch(`${API_BASE}/api/shareholders`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المساهمين'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapShareholderFromApi);
}

export async function fetchShareholderById(id) {
  const res = await fetch(`${API_BASE}/api/shareholders/${id}/detail`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل بيانات المساهم'));
  return mapShareholderFromApi(data);
}

export async function createShareholder(payload) {
  const res = await fetch(`${API_BASE}/api/shareholders`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة المساهم'));
  return mapShareholderFromApi(data);
}

export async function updateShareholder(id, payload) {
  const res = await fetch(`${API_BASE}/api/shareholders/${id}/edit`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ التعديلات'));
  return mapShareholderFromApi(data);
}

export async function deleteShareholder(id) {
  const res = await fetch(`${API_BASE}/api/shareholders/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر حذف المساهم'));
}
